// @flow

/**
 * RiseArtSentryError
 */
export class RiseArtSentryError extends Error {
  constructor(errorData: Object) {
    const { message, ...error } = errorData || {};

    // Pass error message
    super(message || error.detail || error.title || `Unknown Error ${error.type || ''}`);

    // Copy all properties from the error
    Object.assign(this, error);
  }
}
